module.exports = __webpack_public_path__ + "img/streaming_hot.242862ab.svg";